module.exports = __webpack_public_path__ + "static/media/building.71ef06e3.svg";